module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("I2mES"))).then(() => parcelRequire('8rm4T'));